'use strict';

const { h, Component } = require('phy');
const { hydrate } = require('@grpn/hydration');
const { Translate } = require('@grpn/preact-l10n');

const Card = require('../../../components/card');
const RichText = require('../../../modules/shared/views/rich-text');
const LeaderboardBannerWrapper = require('../../../components/leaderboard_banner');

const minItemsToDisplay = 4;
const customContentPosition = 8;
const defaultRowType = 'DEFAULT_ROW';
const customRowType = 'CUSTOM_ROW';
const customBreakoutType = 'CUSTOM_BREAKOUT';

function getMedia(data) {
  const {
    media: advertMedia,
    offerMedia,
    merchant: { merchantMedia } = {},
  } = data;

  const mediaResult = [];

  if (Array.isArray(advertMedia) && advertMedia.length) {
    mediaResult.push(...advertMedia);
  }

  if (Array.isArray(offerMedia) && offerMedia.length) {
    mediaResult.push(...offerMedia);
  }

  if (Array.isArray(merchantMedia) && merchantMedia.length) {
    mediaResult.push(...merchantMedia);
  }

  return mediaResult;
}

function mapper(item) {
  return {
    id: item.offerId,
    offerId: item.offerId,
    media: getMedia(item),
    advertName: item.advertName,
    description: item.description,
    offerTitle: item.offerTitle,
    isExclusive: item.isExclusive,
    merchantName:
      item.merchantName || (item.merchant && item.merchant.merchantName),
    offerCallout: item.offerCallout || item.calloutValue,
    expiryDateTime: item.expiryDate || item.expiryDateTime,
    offerExpiry: item.offerExpiry,
  };
}

function adjustItems(items, customContent, isTouch) {
  const itemsFormatted = items.map(mapper);
  let itemsAdjusted = itemsFormatted;

  if (!isTouch) {
    itemsAdjusted =
      itemsFormatted.length > minItemsToDisplay
        ? itemsFormatted.slice(
            0,
            itemsFormatted.length - (itemsFormatted.length % minItemsToDisplay)
          )
        : itemsFormatted;
  }

  return [
    {
      type: defaultRowType,
      children: [...itemsAdjusted.slice(0, customContentPosition)],
    },
    ...customContent,
    {
      type: defaultRowType,
      children: [...itemsAdjusted.slice(customContentPosition)],
    },
  ];
}

function getOfferImageSize(isTouch, innerWidth) {
  if (isTouch) {
    if (innerWidth) {
      const { offsetWidth } = document.querySelector(
        '.coupons-grid-v2-content .column'
      );
      if (offsetWidth) {
        return [`w_${offsetWidth},h_190,c_fill`];
      }
    }
    return ['w_297,h_190,c_fill'];
  }

  return ['w_248,h_138,c_fill'];
}

function getLogoImageSize() {
  return ['w_68,h_68'];
}

function getRow({ item, routes, innerWidth, isTouch }) {
  switch (item.type) {
    case customBreakoutType:
      return item.children;
    case customRowType:
      return h(
        '.page-container',
        h('.row.coupons-grid-v2-content', h('.twelve.column', item.children))
      );
    default:
      return h(
        '.page-container',
        h(
          '.row.coupons-grid-v2-content',
          item.children.map(child =>
            h(
              '.three.column',
              Card({
                item: child,
                routes,
                isTouch,
                sizes: {
                  offer: getOfferImageSize(isTouch, innerWidth),
                  logo: getLogoImageSize(),
                },
              })
            )
          )
        )
      );
  }
}

class CouponsGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      innerWidth: 0,
    };
    this.windowResize = this.windowResize.bind(this);
  }

  componentDidMount() {
    this.setState({
      innerWidth: window.innerWidth,
    });
    window.addEventListener('resize', this.windowResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.windowResize);
  }

  windowResize() {
    const { innerWidth } = this.state;
    const { innerWidth: windowInnerWidth } = window;

    if (innerWidth === windowInnerWidth) {
      return;
    }

    this.setState({
      innerWidth: windowInnerWidth,
    });
  }

  render() {
    const {
      items,
      routes,
      isTouch,
      showLeaderboardBanner,
      leaderboardAdverts,
      showSeoContent,
    } = this.props;
    const { innerWidth } = this.state;

    const customContent = [
      {
        type: customRowType,
        children: LeaderboardBannerWrapper({
          show: showLeaderboardBanner,
          adverts: leaderboardAdverts,
          isTouch,
          routes,
        }),
      },
      {
        type: customBreakoutType,
        children: RichText({
          display: showSeoContent,
          sectionHeadingKey: 'js.modules.home.PrimarySeoHeading',
          richTextKey: 'js.modules.home.PrimarySeoText',
          hasContrast: true,
          className: 'coupons-grid-v2-content',
        }),
      },
    ];

    if (!items || !items.length) {
      return null;
    }

    const adjustedItems = adjustItems(items, customContent, isTouch);

    return h(
      '.coupons-grid-v2',
      {
        'data-bhw': 'coupons-grid',
      },
      [
        h(
          '.page-container',
          h(
            '.row',
            h(
              Translate,
              { tag: 'h2', attrs: { class: 'secondary-title twelve column' } },
              'js.modules.home.TopOffersHeadingFormat'
            )
          )
        ),
        adjustedItems.map(item =>
          getRow({ item, routes, innerWidth, isTouch })
        ),
      ]
    );
  }
}

module.exports = hydrate('CouponsGrid', CouponsGrid);
module.exports.CouponsGrid = CouponsGrid;
